var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;





export default function () {


    this.checkAvailability = async function (args) {
        try {
            let whosthere = await $.get('/agent/WhosThere');

            if (whosthere === 'Omnya.Agent') {
                return true;
            }

        } catch (e) {

        }
        return false;
    }
    var rejectIfError = function (data) {
        //console.log(data)
        if(data.status!=='OK'){
            return $.Deferred().reject(data).promise();
        } else {
            return $.Deferred().resolve(data).promise();
        }
    }
    this.checkAgentVersion = async function () {
        let build = await $.get('/agent/whosthere/version');

        return build;

    };
    this.checkLibrary = function (libraryRevisionId) {
        return $.get('/agent/Library/GetLibraryInfo/' + libraryRevisionId.toString())
        .then(rejectIfError);
    };
    this.pullLibraryFiles = function (libraryRevisionId) {
        return $.get('/agent/Library/PullLibrary/' + libraryRevisionId.toString())
        .then(rejectIfError);
    };
    this.openLibrary = function (libraryRevisionId) {
        return $.get('/agent/Library/OpenLibrary/' + libraryRevisionId.toString())
        .then(rejectIfError);
    };
    this.syncLibraryFiles = function () {
        return $.post('/agent/Library/SyncCache')
        .then(rejectIfError);
    };
    this.mergeConcatinatedOlbs = function () {
        return $.post('/agent/Library/MergeCacheToProduction')
        .then(rejectIfError);
    };

    this.openLibraryNoPlugin = function (libraryRevisionId) {
        return $.get('/agent/Library/OpenLibraryNoPlugin/' + libraryRevisionId.toString())
        .then(rejectIfError);
    };

    this.makeSymbolSVG = function (libraryRevisionId) {
        return $.Deferred().reject({status:'ERROR',message:'Use Capture plugin to manage Schematic Symbols Library'}).promise();
    };
    this.makeFootprintSVG = function (libraryRevisionId, path = null) {
        return $.get('/agent/Library/GenerateSvg/' + libraryRevisionId.toString() + '?path=' + path)
        .then(rejectIfError);
    };

    this.pushLibrary = function (libraryRevisionId, path = null) {

      if (path != null){
        return $.get('/agent/Library/PushLibrary/' + libraryRevisionId.toString() + '?path=' + path)
        .then(rejectIfError);
      }
        return $.get('/agent/Library/PushLibrary/' + libraryRevisionId.toString())
        .then(rejectIfError);

    };
    this.logImportError = function (obj) {
      console.log(obj)
        return $.get('/agent/Library/LogImportError/' + obj.name.toString() + '?type=' + obj.type.toString() + '&file=' + obj.file.toString() + '&message=' + obj.message.toString())
        .then(rejectIfError);
    };
    this.saveLocalSvg = function (libraryRevisionId,svgTextContent,path = null) {

        let obj = { libraryRevisionId: libraryRevisionId, svgTextContent: svgTextContent, path: path };
        return $.ajax({
            type: "POST",
            dataType: 'json',
            url: "/agent/Library/SaveLocalSvg",
            async: true,
            data: JSON.stringify(obj),
            contentType: 'application/json',
        })
         .then(rejectIfError);

    };

    this.checkProject = function (libraryRevisionId) {
        return $.get('/agent/Projects/GetProjectInfo/' + libraryRevisionId.toString())
        .then(rejectIfError);
    };
    this.pullProjectFiles = function (libraryRevisionId) {
        return $.get('/agent/Projects/PullProject/' + libraryRevisionId.toString())
        .then(rejectIfError);
    };
    this.openProject = function (libraryRevisionId) {
        return $.get('/agent/Projects/OpenProject/' + libraryRevisionId.toString())
        .then(rejectIfError);
    };
    this.openProjectNoPlugin = function (libraryRevisionId) {
        return $.get('/agent/Projects/OpenProjectNoPlugin/' + libraryRevisionId.toString())
        .then(rejectIfError);
    };


    this.pushProject = function (libraryRevisionId) {
        return $.get('/agent/Projects/PushProject/' + libraryRevisionId.toString())
        .then(rejectIfError);

    };




    this.wrapOutErrorPromise = function (result) {
        console.log(result)
        if (result && result.status && result.status === "ERROR") {
            return $.Deferred().resolve(result).promise();
        } else {
            return $.Deferred().reject(result).promise();
        }
    }


    /* RPC Section */

    var rpcRequestQueue= [
       /* {
            guid: null,
            methodName: "",
            parameters: {

            }
        }*/
    ];
    var rpcResponseQueue = [];

    var _asyncDelegate = {};
    this.rpcSubscribe = function(methodName,asyncDelegate) {
        _asyncDelegate[methodName] = asyncDelegate;
        setTimeout(geatherCalls,0);
    };
    var geatherCalls = function() {
        /*mock */
        /*if (_asyncDelegate["LibSync"]){

            let choicePcb = Math.floor(Math.random() * 3);
            let choiceSym = Math.floor(Math.random() * 4);


            let pcbChoices = [
            {
                "libraryName":"PCB",
                "status":"In Sync" ,
                "timestamp":"2022-01-01T00:00:00Z",
                "progress": {
                "done":0,
                "total":0
                }
            },
            {
                "libraryName":"PCB",
                "status":"Downloading" ,
                "timestamp":"2022-01-01T00:00:00Z",
                "progress": {
                "done":3,
                "total":17
                }
            },
            {
                "libraryName":"PCB",
                "status":"Error" ,
                "timestamp":"2022-01-01T00:00:00Z",
                "progress": {
                "done":0,
                "total":0
                }
            }
            ];
            let symChoices = [
            {
                "libraryName":"Schematic parts",
                "status":"Downloading" ,
                "timestamp":"2022-01-01T00:00:00Z",
                "progress": {
                "done":123,
                "total":879
                }
            },
            {
                "libraryName":"Schematic parts",
                "status":"Merging" ,
                "timestamp":"2022-01-01T00:00:00Z",
                "progress": {
                "done":2,
                "total":5
                }
            },
            {
                "libraryName":"Schematic parts",
                "status":"In Sync" ,
                "timestamp":"2022-01-01T00:00:00Z",
                "progress": {
                "done":0,
                "total":0
                }
            },
            {
                "libraryName":"Schematic parts",
                "status":"Error" ,
                "timestamp":"2022-01-01T00:00:00Z",
                "progress": {
                "done":0,
                "total":0
                }
            }
            ];

            let libraryProgress =
            [
                pcbChoices[choicePcb],
                symChoices[choiceSym],


            ];
            _asyncDelegate["LibSync"]({parameters:libraryProgress});
        }*/
        /* end mock */
        //console.log('gathering rpc calls')
        let allSubscriptions = "";
        for (let subsMeth in _asyncDelegate){
            allSubscriptions+=subsMeth+",";
        }
        return $.get('/agent/Rpc/ProvideAwaitingCalls/'+allSubscriptions)
        .then(rejectIfError)
        .then(function(resp){
            //console.log('from rpc list');
            //console.log(resp)
            let cumulatedPromises=[];
            for (let i=0;i<resp.data.length;i++){

                let currentDefinition = resp.data[i];
                //console.log('adding to rpc queue');
                //console.log(currentDefinition)
                cumulatedPromises.push(
                    $.get('/agent/Rpc/'+currentDefinition.methodName+'/'+currentDefinition.guid)
                    .then(rejectIfError)
                    .then(function(paramsResp){
                        rpcRequestQueue.push(paramsResp.data);
                    })
                )

            }
            return Promise.all(cumulatedPromises);
        })
        .then(executeRpcCall,executeRpcCall);
    };
    var executeRpcCall = function(){
        //console.log('will exec rpc call');
        let currentRpcMessageToHandle = rpcRequestQueue.shift();
        //console.log(currentRpcMessageToHandle)
        if (currentRpcMessageToHandle && _asyncDelegate[currentRpcMessageToHandle.methodName]){
            //console.log("Will exec the rpc method for: "+currentRpcMessageToHandle.methodName+', call id:'+currentRpcMessageToHandle.guid)
            return _asyncDelegate[currentRpcMessageToHandle.methodName](currentRpcMessageToHandle)
                .then(function(newResp){
                    newResp.guid = currentRpcMessageToHandle.guid;
                    //console.log("Addign rpc result to response queue");
                    rpcResponseQueue.push(newResp);
                    return $.Deferred().resolve().promise();
                })
                .then(sendRpcResponse)
                .then(executeRpcCall);

        } else {
            setTimeout(geatherCalls,10000);
            return $.Deferred().resolve().promise();
        }
    };
    var sendRpcResponse = function() {
        //console.log("Looking for prepared rpc responses");
        var resp = rpcResponseQueue.shift();
        if (resp){
            //console.log("Sending RPC response to the method: "+resp.methodName+', call id:'+resp.guid)
            return $.ajax({
                type: "POST",
                dataType: 'json',
                url: "/agent/Rpc/"+(resp.methodName),
                async: true,
                data: JSON.stringify(resp),
                contentType: 'application/json',
            })
            .then(
                rejectIfError
                ,function(){
                    console.log("ERROR while sending RPC response to the method: "+resp.methodName+', call id:'+resp.guid)
                    return $.Deferred().resolve().promise();
                })
            .then(
                function() {
                    return $.Deferred().resolve().promise();
                },
                function() {
                    return $.Deferred().resolve().promise();
                }
            );

        } else {
            console.log("No further RPC responses to send")
        }
        return $.Deferred().resolve().promise();


    };

}




// WEBPACK FOOTER //
// ./src/Tools/agentAPI.js